import { render } from "./MetricGroupList.vue?vue&type=template&id=7fb94161"
import script from "./MetricGroupList.vue?vue&type=script&lang=js"
export * from "./MetricGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__